import React, { useEffect, useMemo, useState } from "react";
import { Col, Row, Card, CardBody, Badge, Button, Spinner, Alert } from "reactstrap";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const BASE_URL = "https://harmanappapi.stechomeyazilim.info";

const fmtDate = (v) => (v ? new Date(v).toLocaleString("tr-TR") : "—");

const KayitliAramalar = () => {
  document.title = "Kayıtlı Aramalar | HarmanaGEL";

  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const token = localStorage.getItem("token") || authUser?.Token;
  const headers = { "Content-Type": "application/json", Authorization: `Bearer ${token}` };

  const [liste, setListe] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [successMsg, setSuccessMsg] = useState("");

  const fetchListe = async () => {
    setIsLoading(true);
    setError(null);
    try {
      const url = `${BASE_URL}/KAYITLI_ARAMALAR?$orderby=ID desc&$top=1000` +
        `&$expand=KULLANICILAR($select=AD_SOYAD,ISLETME_AD),KATEGORILER($select=AD)`;
      const res = await fetch(url, { headers });
      const result = await res.json();
      setListe(result.value || []);
    } catch {
      setError("Kayıtlı aramalar yüklenirken hata oluştu.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => { fetchListe(); }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Bu kayıtlı aramayı silmek istediğinize emin misiniz?")) return;
    try {
      await fetch(`${BASE_URL}/KAYITLI_ARAMALAR(${id})`, { method: "DELETE", headers });
      setSuccessMsg("Kayıt silindi.");
      fetchListe();
      setTimeout(() => setSuccessMsg(""), 3000);
    } catch {
      setError("Silme sırasında hata oluştu.");
    }
  };

  const columns = useMemo(() => [
    { header: "#", accessorKey: "ID", enableSorting: true, cell: (c) => <strong>#{c.getValue()}</strong> },
    {
      header: "Kullanıcı", accessorKey: "KULLANICI_ID", enableSorting: true,
      cell: (c) => {
        const u = c.row.original.KULLANICILAR;
        return <span className="fw-medium">{u?.AD_SOYAD || u?.ISLETME_AD || `#${c.getValue()}`}</span>;
      },
    },
    {
      header: "Kategori", accessorKey: "KATEGORI_ID", enableSorting: true,
      cell: (c) => {
        const k = c.row.original.KATEGORILER;
        return <Badge color="light" className="text-dark">{k?.AD || (c.getValue() ? `#${c.getValue()}` : "—")}</Badge>;
      },
    },
    {
      header: "Arama Adı", accessorKey: "ARAMA_ADI", enableSorting: true,
      cell: (c) => <span className="fw-medium">{c.getValue() || "—"}</span>,
    },
    {
      header: "Kriterler", accessorKey: "ARAMA_KRITERLERI", enableSorting: false,
      cell: (c) => {
        const v = c.getValue() || "";
        return <small className="text-muted">{v.length > 60 ? v.slice(0, 60) + "…" : (v || "—")}</small>;
      },
    },
    {
      header: "Kayıt Tarihi", accessorKey: "KAYIT_TARIHI", enableSorting: true,
      cell: (c) => <small className="text-muted">{fmtDate(c.getValue())}</small>,
    },
    {
      header: "Durum", accessorKey: "AKTIF_DURUM", enableSorting: true,
      cell: (c) => {
        const v = c.getValue();
        const aktif = v === "1" || v === "Aktif" || v === true || v === "true";
        return <Badge color={aktif ? "success" : "secondary"}>{aktif ? "Aktif" : (v || "Pasif")}</Badge>;
      },
    },
    {
      header: "İşlemler", enableSorting: false,
      cell: (cellProps) => (
        <Button color="danger" size="sm" outline onClick={() => handleDelete(cellProps.row.original.ID)}>
          <i className="bx bx-trash" />
        </Button>
      ),
    },
  ], []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs title="İlan Yönetimi" breadcrumbItem="Kayıtlı Aramalar" />
          {successMsg && <Alert color="success">{successMsg}</Alert>}
          {error && <Alert color="danger" toggle={() => setError(null)}>{error}</Alert>}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div className="mb-3 d-flex justify-content-between align-items-center">
                    <div>
                      <h4 className="card-title mb-1">Kayıtlı Aramalar</h4>
                      <p className="text-muted small mb-0">
                        Kullanıcıların kaydettiği arama filtreleri. Toplam {liste.length} kayıt.
                      </p>
                    </div>
                    <Button color="primary" size="sm" onClick={fetchListe} disabled={isLoading}>
                      <i className="bx bx-refresh" /> Yenile
                    </Button>
                  </div>
                  {isLoading ? (
                    <div className="text-center py-5"><Spinner color="primary" /></div>
                  ) : (
                    <TableContainer
                      columns={columns}
                      data={liste}
                      isGlobalFilter={true}
                      isPagination={true}
                      customPageSize={15}
                      SearchPlaceholder="Ara..."
                      tableClass="align-middle table-nowrap table-hover"
                      theadClass="table-light"
                      paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                      pagination="pagination pagination-rounded justify-content-end mb-2"
                    />
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default KayitliAramalar;
